import { useMemo } from "react"
import { Svg, Rect } from "@react-pdf/renderer"
import QRCode from "qrcode"

/** @returns {{ modules: { size: number, get: (row: number, col: number) => boolean } } | null} */
function createQrCode(value) {
    const text = String(value ?? "").trim()
    if (!text) {
        return null
    }

    try {
        return QRCode.create(text, { errorCorrectionLevel: "L" })
    } catch (error) {
        console.error("BoxLabelQrCode encoding failed:", error)
        return null
    }
}

/**
 * QR code at an exact square size — vector modules for crisp PDF output.
 *
 * @param {{
 *   value: string,
 *   size: number,
 * }} props Size in PDF points (width and height).
 */
export default function BoxLabelQrCode({ value, size }) {
    const modules = useMemo(() => createQrCode(value)?.modules ?? null, [value])

    const rects = useMemo(() => {
        if (!modules) {
            return []
        }

        const gridSize = modules.size
        const moduleSize = size / gridSize
        const cells = []

        for (let row = 0; row < gridSize; row++) {
            for (let col = 0; col < gridSize; col++) {
                if (modules.get(row, col)) {
                    cells.push({
                        x: col * moduleSize,
                        y: row * moduleSize,
                        width: moduleSize,
                        height: moduleSize,
                    })
                }
            }
        }

        return cells
    }, [modules, size])

    if (rects.length === 0) {
        return null
    }

    return (
        <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {rects.map((cell, index) => (
                <Rect
                    key={index}
                    x={cell.x}
                    y={cell.y}
                    width={cell.width}
                    height={cell.height}
                    fill="#000000"
                />
            ))}
        </Svg>
    )
}
